import axios from "axios";
import { apiInstance } from "./config";


// Fetch all donors
const getAllDonors = async (endpoint: string, payload: any) => {
  try {
    const response = await apiInstance.post(endpoint, payload);
    return response.data;
  } catch (error: any) {
    if (error?.name === "CanceledError") {
      console.log('Fetching all donors aborted');
    } else {
      console.error('Error fetching all donors:', error);
      throw error;
    }
  }
};

// Fetch a specific donor by ID
const getDonorById = async (endpoint: string, payload: any) => {
  try {
    const response = await apiInstance.post(endpoint, payload);
    return response.data;
  } catch (error: any) {
    if (error?.name === "CanceledError") {
      console.log(`Fetching donor with endpoint ${endpoint} aborted`);
    } else {
      console.error(`Error fetching donor with endpoint ${endpoint}:`, error);
      throw error;
    }
  }
};

// Add a new donor
const addDonor = async (endpoint: string, payload: object) => {
  try {
    const response = await apiInstance.post(endpoint, payload);
    return response.data;
  } catch (error: any) {
    if (error?.name === "CanceledError") {
      console.log('Adding donor aborted');
    } else {
      console.error('Error adding donor:', error);
      throw error;
    }
  }
};

// Update a donor's details
const updateDonor = async (endpoint: string, data: object) => {
  try {
    const response = await apiInstance.put(endpoint, data);
    return response.data;
  } catch (error: any) {
    if (error?.name === "CanceledError") {
      console.log(`Updating donor with endpoint ${endpoint} aborted`);
    } else {
      console.error(`Error updating donor with endpoint ${endpoint}:`, error);
      throw error;
    }
  }
};

// Delete a donor
const deleteDonor = async (endpoint: string) => {
  try {
    const response = await apiInstance.delete(endpoint);
    return response.data;
  } catch (error: any) {
    if (error?.name === "CanceledError") {
      console.log(`Deleting donor with endpoint ${endpoint} aborted`);
    } else {
      console.error(`Error deleting donor with endpoint ${endpoint}:`, error);
      throw error;
    }
  }
};





const searchDonors = async (endpoint: string, payload: any) => {
  try {
    const response = await await apiInstance.post(endpoint, payload);
    return response.data;
  } catch (error: any) {
    if (error?.name === "CanceledError") {
      console.log('Searching donors aborted');
    } else {
      console.error('Error searching donors:', error);
      throw error;
    }
  }
};

const getCandidates = async (endpoint: string, payload: any) => {
  try {
    const response = await apiInstance.post(endpoint, payload);
    return response.data;
  } catch (error: any) {
    if (error?.name === "CanceledError") {
      console.log('Fetching candidates aborted');
    } else {
      console.error('Error fetching candidates:', error);
      throw error;
    }
  }
};

const getStates = async (endpoint: string, payload: any) => {
  try {
    const response = await apiInstance.post(endpoint, payload);
    return response.data;
  } catch (error: any) {
    if (error?.name === "CanceledError") {
      console.log('Fetching states aborted');
    } else {
      console.error('Error fetching states:', error);
      throw error;
    }
  }
};


const getDonationsById = async (endpoint: string, payload: any) => {
  try {
    const response = await apiInstance.post(endpoint, payload);
    return response.data;
  } catch (error: any) {
    if (error?.name === "CanceledError") {
      console.log('Fetching donations aborted');
    } else {
      console.error('Error fetching donations:', error);
      throw error;
    }
  }
};

const getCallRecords = async (endpoint: string, payload: any) => {
  try {
    const response = await apiInstance.post(endpoint, payload);
    return response.data;
  } catch (error: any) {
    if (error?.name === "CanceledError") {
      console.log('Fetching call records aborted');
    } else {
      console.error('Error fetching call records:', error);
      throw error;
    }
  }
};

const createCallRecord = async (endpoint: string, payload: any) => {
  try {
    const response = await apiInstance.post(endpoint, payload);
    return response.data;
  } catch (error: any) {
    if (error?.name === "CanceledError") {
      console.log('Creating call record aborted');
    } else {
      console.error('Error creating call record:', error);
      throw error;
    }
  }
};


const createCallList = async (endpoint: string, payload: any) => {
  try {
    const response = await apiInstance.post(endpoint, payload);
    return response.data;
  } catch (error: any) {
    if (error?.name === "CanceledError") {
      console.log('Create call list request canceled');
    } else {
      console.error('Error creating call list:', error);
      throw error;
    }
  }
};

const createDonation = async (endpoint: string, payload: any) => {
  try {
    const response = await apiInstance.post(endpoint, payload);
    return response.data;
  } catch (error: any) {
    if (error?.name === "CanceledError") {
      console.log('Creating donation aborted');
    } else {
      console.error('Error creating donation:', error);
      throw error;
    }
  }
}

const getTags = async (endpoint: string, payload: any) => {
  try {
    const response = await apiInstance.post(endpoint, payload);
    return response.data;
  } catch (error: any) {
    if (error?.name === "CanceledError") {
      console.log('Fetching tags aborted');
    } else {
      console.error('Error fetching tags:', error);
      throw error;
    }
  }
}

const addTag = async (endpoint: string, payload: any) => {
  try {
    const response = await apiInstance.post(endpoint, payload);
    return response.data;
  } catch (error: any) {
    console.error('Error adding tag:', error);
    throw error;
  }
}

// Improve the Twilio token function with better error handling
const getTwilioToken = async (endpoint: string, payload: any) => {
  try {
    const response = await apiInstance.post(endpoint, payload = {});
    return response.data;
  } catch (error: any) {
    console.error('Error getting Twilio token:', error);
    throw error;
  }
}
const unsubscribe = async (endpoint: string, payload: any) => {
  try {
    const response = await apiInstance.post(endpoint, payload);
    return response.data;
  } catch (error: any) {
    console.error('Error unsubscribing:', error);
    throw error;
  }
};


const sendMessage = async (endpoint: string, payload: any) => {
  try {
    const response = await apiInstance.post(endpoint, payload);
    return response.data;
  } catch (error: any) {
    console.error('Error sending message:', error);
    throw error;
  }
}

// Get preset messages
const getPresetMessages = async (endpoint: string, payload: any) => {
  try {
    const response = await apiInstance.post(endpoint, payload);
    return response.data;
  } catch (error: any) {
    console.error('Error fetching preset messages:', error);
    throw error;
  }
}

// Add a new preset message
const addPresetMessage = async (endpoint: string, payload: any) => {
  try {
    const response = await apiInstance.post(endpoint, payload);
    return response.data;
  } catch (error: any) {
    console.error('Error adding preset message:', error);
    throw error;
  }
}

// Group the functions for easier use
export const DONOR_SERVICE = {

  getAllDonors,
  getDonorById,
  addDonor,
  updateDonor,
  deleteDonor,
  searchDonors,
  getCandidates,
  getStates,
  getDonationsById,
  getCallRecords,
  createCallRecord,
  createCallList,
  createDonation,
  getTags,
  addTag,
  getTwilioToken,
  unsubscribe,
  sendMessage,
  getPresetMessages,
  addPresetMessage
};
